module.exports = "/_next/static/images/smith_tsukune-0b75983001356699284d936d2d89bbc4.jpeg";